// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kDht","expireSoon":"styles_expireSoon__2lF7i"};